import { computed, onMounted, ref } from "vue";
import * as Sentry from "@sentry/vue";

import { EEnvironmentType, useEnvironmentStore } from "@/stores/environmentStore";

export function useSentryFeedback() {
  const environmentStore = useEnvironmentStore();

  const feedback = ref<ReturnType<typeof Sentry.getFeedback> | null>(null);

  onMounted(() => {
    feedback.value = Sentry.getFeedback();
  });

  const isDisabled = computed(() => environmentStore.currentEnv === EEnvironmentType.DEV);

  const openFeedback = async (): Promise<void> => {
    if (!feedback.value) {
      return;
    }

    const form = await feedback.value.createForm();
    form.appendToDom();
    form.open();
  };

  return {
    isDisabled,
    openFeedback,
  };
}
